<template>
    <DropDownMenu v-if="currentDayTemplate !=null" :menus="menus"></DropDownMenu>
</template>
<script>
    import Vue from 'vue';
    import Translations from '@/store/translations';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import DropDownMenu from'@/components/common/DropDownMenu.vue';
    import EventBus from '@/eventbus';

    export default {
        name: "WeekTemplateActions",
        store,
        components: {
            DropDownMenu
        },
        computed: {
            Translations: () => Translations,
            ...mapState(["currentDayTemplate","isLoadingDayTemplate"]),
        },
        data() {
            return {
                menus: [
                    {
                        external: true,
                        iconClass: "fa-cog",
                        title: Translations.sections.dayTemplates.details.actions.edit,
                        action: this.startEditDayTemplate
                    },
                    {
                        external: false, iconClass: "fa-cog", title: Translations.sections.dayTemplates.details.actions.edit,
                        action: this.startEditDayTemplate
                    },
                    {
                        external: false, iconClass: "fa-clone", title: Translations.sections.dayTemplates.details.actions.duplicate,
                        action: this.startDuplicateDayTemplate
                    },
                    { external: false, isDivider: true },
                    {
                        external: false, iconClass: "fa-trash-alt", title: Translations.sections.dayTemplates.details.actions.delete,
                        action: this.startDeleteDayTemplate
                    },
                ]
            }
        },
        methods: {
            startDeleteDayTemplate(e) {
                EventBus.$emit("onDayTemplateDelete", this.currentDayTemplate.uid);
            },
            startDuplicateDayTemplate(e) { EventBus.$emit("onDayTemplateDuplicate", this.currentDayTemplate.uid); },
            startEditDayTemplate(e) { EventBus.$emit("onDayTemplateEdition", this.currentDayTemplate.uid); },
        }
    }
</script>

<style scoped>
</style>
